<app-nav />
<router-outlet/>
<app-footer />